import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { EnvService } from 'src/app/services/env.service';
import { AlertRecord } from './interface/alertRecord.interface';

@Injectable({
  providedIn: 'root'
})
export class AlertRecordService {
  readonly baseUrl = `${this.env.URL_API_V1}/alert_record`;

  constructor(private readonly http: HttpClient, private env: EnvService) { }

  filterData = new Subject();

  updatedRecord = new Subject<any>();
  createAlertRecord(caseRecord) {
    return (
      this.http
        .post<AlertRecord[]>(`${this.baseUrl}/create`, caseRecord)
        // .pipe(take(1))
        .subscribe()
    );
  }

  getAllAlertRecord(id) {
    return this.http.get<AlertRecord[]>(`${this.baseUrl}/getAll/${id}`);
  }
}
